import { create } from "zustand";
import {
  THEME_KEY,
  THEME_MODES,
  applyTheme,
  getStoredTheme,
  resolveIsDark,
  systemPrefersDark,
} from "@/utils/theme";

// Bind the OS-preference listener only once, regardless of how many times
// initTheme runs across remounts.
let mediaListenerBound = false;

export const useThemeStore = create((set, get) => ({
  // The user's chosen preference: "system" | "light" | "dark".
  theme: getStoredTheme(),
  // The effective appearance after resolving "system": "light" | "dark".
  resolvedTheme: resolveIsDark() ? "dark" : "light",

  // Sync state with what's stored / on <html>, and start following the OS
  // while the preference is "system".
  initTheme: () => {
    const theme = getStoredTheme();
    applyTheme(theme);
    set({ theme, resolvedTheme: resolveIsDark(theme) ? "dark" : "light" });

    if (!mediaListenerBound && typeof window.matchMedia === "function") {
      window
        .matchMedia("(prefers-color-scheme: dark)")
        .addEventListener("change", () => {
          if (get().theme !== "system") return;
          applyTheme("system");
          set({ resolvedTheme: systemPrefersDark() ? "dark" : "light" });
        });
      mediaListenerBound = true;
    }
  },

  // Persist and apply a new preference.
  setTheme: (theme) => {
    if (!THEME_MODES.includes(theme)) return;
    try {
      localStorage.setItem(THEME_KEY, theme);
    } catch {
      // Ignore storage failures (private mode, blocked cookies, etc.).
    }
    applyTheme(theme);
    set({ theme, resolvedTheme: resolveIsDark(theme) ? "dark" : "light" });
  },
}));
